'use client';

import { EventsEnum } from '@hubxtech/hubx-client-analytics-package/lib/src/enum/pdfGenius/eventsEnum';

import { downloadSuccessService } from '@/features/tool/api/services/downloadSuccessService';
import {
  type LogHubxEventParams,
  resolveSourceParam,
} from '@/lib/analytics/services/log-hubx-event-adapter';
import { selectAuth } from '@/store/slices/authSlice';

type ReportDownloadSuccessArgs = {
  eventName: string;
  params: LogHubxEventParams;
  auth: ReturnType<typeof selectAuth>;
  clientId: string | null;
  currentUrl: string;
  isPlanActive?: boolean;
};

function getDownloadReportPlatform(): 'web' | 'mobile' {
  if (typeof window === 'undefined') {
    return 'web';
  }

  return window.innerWidth < 768 ? 'mobile' : 'web';
}

export function reportDownloadSuccess({
  eventName,
  params,
  auth,
  clientId,
  currentUrl,
  isPlanActive,
}: ReportDownloadSuccessArgs): void {
  if (eventName !== EventsEnum.DOWNLOAD_SUCCESS) {
    return;
  }

  try {
    const stateUser = auth.user as any;
    const toolName = resolveSourceParam(params) || '';
    const platform = getDownloadReportPlatform();
    const processId =
      typeof crypto !== 'undefined' && 'randomUUID' in crypto
        ? crypto.randomUUID()
        : `${Date.now()}-${Math.random().toString(16).slice(2)}`;
    void downloadSuccessService.reportDownloadSuccess({
      userId: stateUser?._id ?? stateUser?.uid,
      processId,
      activityType: 'download',
      premium: stateUser?.isPremium ?? stateUser?.premium ?? isPlanActive,
      platform,
      userSource: stateUser?.source,
      modelName: toolName || undefined,
      eventName: 'download_file_success',
      credit: stateUser?.credit,
      data: JSON.stringify({
        tool: toolName || undefined,
        modelName: toolName || undefined,
        eventName: 'download_file_success',
        url: currentUrl,
        email: stateUser?.email,
        clientId: clientId ?? undefined,
      }),
    });
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      console.error('[analytics] download success report failed', err);
    }
  }
}
